import {SerializedStyles} from '@emotion/react';
import {css, PopperProps, Popper, useTheme} from '@mui/material';
import * as React from 'react';

import {GetStylesFunction} from 'src/js/common/types';
import classNames from 'classnames';
import {useEffect, useRef, useState} from 'react';
import {useDebounce} from '../hooks';

interface OwnProps extends PopperProps {
  inputCss?: SerializedStyles;
  children: React.ReactNode;
  hasTooltip: boolean;
  style?: React.CSSProperties;
  isTooltipInNavigationMenu?: boolean;
  isNavigationOpen?: boolean;
}

type Props = OwnProps;

export const DlMuiPopper: React.FC<Props> = (props) => {
  const {inputCss, hasTooltip = false, anchorEl, open, children, style, isTooltipInNavigationMenu, isNavigationOpen, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss}});
  const [delayedOpen, setDelayedOpen] = useState<boolean>(false);

  const delayInMilliseconds = 500;
  const debounced = useDebounce(() => {
    if (open) {
      setDelayedOpen(true);
    }
  }, delayInMilliseconds);

  useEffect(() => {
    if (isTooltipInNavigationMenu) {
      if (open) {
        return debounced();
      } else {
        setDelayedOpen(false);
      }
    }
    setDelayedOpen(open);
  }, [open, hasTooltip, delayInMilliseconds]);

  return hasTooltip ? (
    <Popper
      data-name={'dl-mui-popper--popper'}
      // id={id}
      {...restProps}
      open={delayedOpen}
      anchorEl={anchorEl}
      css={styles.popper}
      className={classNames({
        tooltipInNavigationMenu: isTooltipInNavigationMenu && !isNavigationOpen,
      })}
    >
      {children}
    </Popper>
  ) : null;
};

DlMuiPopper.displayName = 'DlMuiPopper';

const getStyles: GetStylesFunction = (options) => ({
  popper: css`
    z-index: 1300;
    width: fit-content;
    max-width: 300px;
    background-color: ${options?.theme?.palette.custom.coolGray['700']};
    color: #ffffff;
    border-radius: ${options?.theme?.borderRadius};
    padding: ${options?.theme?.spacing(3)};
    line-height: 15px;
    ${options?.params?.inputCss ?? ''};

    &.tooltipInNavigationMenu {
      margin-left: 2px !important;
    }
  `,
});
